import script from "./CustomIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomIcon.vue?vue&type=script&setup=true&lang=js"

import "./CustomIcon.vue?vue&type=style&index=0&id=5ecf5990&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ecf5990"]])

export default __exports__